import { render, staticRenderFns } from "./dragDropEmailTextBlock.vue?vue&type=template&id=b0493836&"
import script from "./dragDropEmailTextBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropEmailTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports